import { Modal } from 'antd'
import { errorMessage } from './function.errorMessage'

const ERROR_TITLES: Record<string, string> = {
  MOBILE_DUPLICATED: 'Mobile number already in use',
}

export function showApiErrorModal(error: any, fallbackTitle = 'Something went wrong'): void {
  const data = error?.response?.data || error
  const title = (data?.name && ERROR_TITLES[data.name]) || fallbackTitle
  const content = errorMessage(data) || 'Please try again later.'
  Modal.error({
    title,
    content: typeof content === 'string' ? content : 'Please try again later.',
    centered: true,
  })
}
